import React from "react";
import { ConfigProvider } from "antd";
import dayjs from "dayjs";
import FaLocal from "antd/locale/fa_IR";
import "dayjs/locale/fa";
import ClientRouter from "@/router";
import { AuthProvider } from "@/providers/AuthContext";

dayjs.locale("fa");

function App() {
  return (
    <AuthProvider>
      <ConfigProvider
        locale={FaLocal}
        direction={"rtl"}
        theme={{
          token: {
            colorPrimary: "#a05195",
            borderRadius: 10,
            colorBgContainer: "#fff",
          },
          components: {
            Layout: {
              headerBg: "#fff",
              headerHeight: 124,
              headerPadding: "0",
              siderBg: "#a05195",
            },
            Menu: {
              itemHoverColor: "#fff",
              itemSelectedColor: "#fff",
              itemSelectedBg: "rgba(0,0,0,0.08)",
              itemActiveBg: "rgba(0,0,0,0.08)",
              itemHoverBg: "rgba(0,0,0,0.08)",
            },
            Table: {
              headerColor: "#1C2767",
              cellPaddingBlock: 10,
              cellPaddingInline: 0,
            },
            Button: {
              borderColorDisabled: "#a05195",
            },
            Select: {
              optionSelectedColor: "#fff",
            },
          },
        }}
      >
        <ClientRouter />
      </ConfigProvider>
    </AuthProvider>
  );
}

export default App;
